export default function navigation() {
    const nav = document.querySelector('[data-navigation]')
    const api = {}

    setNavHeight(nav)
    burger(nav, api)
    products(nav, api)
    languageSwitcher(nav, api)
}

function setNavHeight(nav) {
    if (!nav) return
    const root = document.documentElement
    const set = () => {
        const h = `${nav.offsetHeight}px`
        root.style.setProperty('--navigation-height', h)
        nav.style.setProperty('--navigation-height', h)
    }
    set()
    new ResizeObserver(set).observe(nav)
}

function burger(nav, api) {
    const btn = nav?.querySelector('.btn-burger')
    const modal = nav?.querySelector('.menu-modal')
    if (!btn || !modal) return

    const setOpen = (open) => {
        if (open) {
            api.setProductsOpen?.(false)
            api.setLanguageOpen?.(false)
        }
        btn.classList.toggle('active', open)
        modal.classList.toggle('active', open)
        btn.setAttribute('aria-expanded', String(open))
        modal.setAttribute('aria-hidden', String(!open))
        document.body.classList.toggle('menu-open', open || nav.querySelector('.products-modal.active'))
    }

    api.setBurgerOpen = setOpen
    btn.addEventListener('click', () => {
        const productsOpen = nav.querySelector('.products-modal.active')
        if (btn.classList.contains('active') && productsOpen) {
            api.setProductsOpen?.(false)
            setOpen(false)
            return
        }
        setOpen(!btn.classList.contains('active'))
    })
    modal.querySelector('[data-menu-close]')?.addEventListener('click', () => setOpen(false))
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && btn.classList.contains('active')) setOpen(false)
    })
}

function products(nav, api) {
    const trigger = nav?.querySelector('.main-menu a[href="#products"], .main-menu a[href$="#products"]')
    const modal = nav?.querySelector('.products-modal')
    if (!modal) return

    const isMobile = () => window.matchMedia('(max-width: 1077px)').matches

    const showCategory = (slug) => {
        modal.querySelectorAll('[data-category]').forEach((el) => {
            el.classList.toggle('active', el.dataset.category === slug)
        })
    }

    const setOpen = (open, slug) => {
        if (open && slug) showCategory(slug)
        if (open) api.setLanguageOpen?.(false)
        if (open && !isMobile()) api.setBurgerOpen?.(false)
        if (trigger) {
            trigger.classList.toggle('active', open)
            trigger.setAttribute('aria-expanded', String(open))
        }
        modal.classList.toggle('active', open)
        modal.setAttribute('aria-hidden', String(!open))
        document.body.classList.toggle(
            'menu-open',
            open || nav.querySelector('.menu-modal.active') || nav.querySelector('.btn-burger.active')
        )
    }

    api.setProductsOpen = setOpen

    if (trigger) {
        trigger.setAttribute('aria-controls', 'products-modal')
        trigger.setAttribute('aria-expanded', 'false')
        trigger.addEventListener('click', (e) => {
            e.preventDefault()
            setOpen(!trigger.classList.contains('active'))
        })
    }

    document.addEventListener('click', (e) => {
        if (!modal.classList.contains('active') || isMobile()) return
        if (trigger?.contains(e.target) || modal.querySelector('.products-modal__panel')?.contains(e.target)) return
        setOpen(false)
    })

    modal.querySelector('.products-modal__panel')?.addEventListener('click', (e) => {
        const cat = e.target.closest('.products-modal__category [data-category]')
        if (!cat) return
        e.preventDefault()
        showCategory(cat.dataset.category)
    })

    nav.querySelectorAll('[data-open-products]').forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault()
            setOpen(true, link.dataset.openProducts)
        })
    })

    document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href*="#products-modal_"]')
        if (!link) return
        const slug = decodeURIComponent(link.hash.replace(/^#products-modal_/, ''))
        if (!slug || slug === link.hash) return
        e.preventDefault()
        setOpen(true, slug)
    })

    modal.querySelector('[data-products-back]')?.addEventListener('click', () => {
        setOpen(false)
    })

    modal.querySelector('[data-menu-close]')?.addEventListener('click', () => {
        setOpen(false)
        if (isMobile()) api.setBurgerOpen?.(false)
    })

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !modal.classList.contains('active')) return
        setOpen(false)
    })
}

function languageSwitcher(nav, api) {
    const root = nav?.querySelector('.language-switcher')
    const btn = root?.querySelector('.language-switcher__toggle')
    const list = root?.querySelector('.language-switcher__list')
    if (!root || !btn || !list) return

    const setOpen = (open) => {
        if (open) {
            api.setBurgerOpen?.(false)
            api.setProductsOpen?.(false)
        }
        root.classList.toggle('active', open)
        btn.classList.toggle('active', open)
        btn.setAttribute('aria-expanded', String(open))
        list.setAttribute('aria-hidden', String(!open))
    }

    api.setLanguageOpen = setOpen

    btn.addEventListener('click', () => setOpen(!root.classList.contains('active')))

    list.addEventListener('click', (e) => {
        const link = e.target.closest('a')
        if (!link) return
        if (link.getAttribute('aria-current') === 'true') e.preventDefault()
        setOpen(false)
    })

    document.addEventListener('click', (e) => {
        if (!root.classList.contains('active') || root.contains(e.target)) return
        setOpen(false)
    })

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && root.classList.contains('active')) setOpen(false)
    })
}
